import {Component} from 'react';
import AddCardModal from "../modals/AddCardModal";
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import DeleteCardConfirmModal from "../modals/DeleteCardConfirmModal";
import FastCreditModal from "../modals/FastCreditModal";
import Badge from 'react-bootstrap/lib/Badge';
import Button from 'react-bootstrap/lib/Button';
import CardSub from "../subcomponents/CardSub";
import AzureTable from "../AzureTable";
import LoadingModal from "../modals/LoadingModal";
import JsBarcode from "jsbarcode";
import { createCanvas } from "canvas";
import JSZip from "jszip";
import EditCardModal from "../modals/EditCardModal";

const GET_CARDS_URL = "https://qibipay.azurewebsites.net/api/GetList";

class DevicesTab extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - logout
             - cards
             - onCardRemove
             - onCardAdd
             - globalConfig
        */
        super(props);

        this.state = {
            addCardOpen: false,
            editCard: null,

            deleteCardOpen: false,
            deleteCard: null,

            quickCreditOpen: false,
            quickCreditCardId: null,

            cardFieldsEdit: null,

            loading: true
        };

    }

    downloadCardIds(cardIds) {
        const zip = new JSZip();
        for(let cardId of cardIds) {
            const canvas = createCanvas();
            JsBarcode(canvas, cardId);
            zip.file(cardId+".png", canvas.toDataURL().split(",")[1], {base64: true});
        }
        zip.generateAsync({type: "blob"}).then((content) => {
            this.saveData(content, "export.zip");
        })
    }

    saveDataURI(uriData, fileName) {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = uriData;
        a.download = fileName;
        a.click();
        document.body.removeChild(a);
    }

    saveData(blobData, fileName) {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        var blob = new Blob([blobData], {type: "octet/stream"}),
            url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }

    generateCards() {
        let queryBase = "SELECT * FROM c WHERE c.userId=\"replace_with_new_document_id\" AND c.cardId IN (";
        const arr = [];
        for(let i=0;i<500;i++) {
            const num = Math.floor(Math.random() * 9999999999);
            let str = num.toFixed(0);
            while(str.length<10) {
                str = "0"+str;
            }
            arr.push("\""+str+"\"");
        }
        queryBase += arr.concat() + ")";
        console.log(queryBase);
    }

    render() {
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-credit-card"></i> Cards <a href="javascript:void(0);" style={{
                                fontSize: "15px"
                            }} onClick={() => {
                                this.tableRef.resetTable();
                            }}><i className="fa fa-sync"></i></a></h3>
                            <div className="ml-auto text-right">
                                <Button bsStyle='success' className="mr-3" onClick = {() => this.setState({quickCreditOpen: true, quickCreditCardId: null})}>
                                    <i className="mdi mdi-notification-clear-all font-16"></i>Quick credit
                                </Button>
                                <button className="btn btn-primary mr-3" onClick = {() => this.setState({addCardOpen: true, editCard: null})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Card
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <DeleteCardConfirmModal    access_code={this.props.access_code}
                                           card={this.state.deleteCard}
                                           open={this.state.deleteCardOpen}
                                           onClose={() => this.setState({
                                               deleteCardOpen: false,
                                               deleteCard: null
                                           })}
                                           onCardRemove={() => {
                                               this.tableRef.resetTable();
                                           }}
                                           logout={this.props.logout}/>

                <FastCreditModal            access_code={this.props.access_code}
                                            open={this.state.quickCreditOpen}
                                            onClose={() => this.setState({
                                                quickCreditOpen: false
                                            })}
                                            globalConfig={this.props.globalConfig}
                                            cardId={this.state.quickCreditCardId}
                                            tableRef={this.tableRef}
                                            logout={this.props.logout} />

                <AddCardModal   access_code={this.props.access_code}
                                open={this.state.addCardOpen}
                                onClose={() => this.setState({addCardOpen: false})}
                                onCardAdd={() => {
                                    this.tableRef.resetTable();
                                }}
                                logout={this.props.logout}/>

                <EditCardModal access_code={this.props.access_code}
                               open={this.state.cardFieldsEdit!=null}
                               card={this.state.cardFieldsEdit}
                               onClose={() => this.setState({cardFieldsEdit: null})}
                               onCardEdit={() => {
                                   this.tableRef.resetTable();
                               }}
                               logout={this.props.logout}/>

                <LoadingModal title="Loading..."
                            text="Loading cards data..."
                            open={this.state.loading}/>

                <div className="container-fluid">
                    <AzureTable
                        logout={this.props.logout}
                        access_code={this.props.access_code}
                        onLoad={() => {
                            this.setState({
                                loading: false
                            });
                        }}
                        tableRef={(ref) => {
                            this.tableRef = ref;
                        }}
                        functionUrl={GET_CARDS_URL}
                        defaultSorted={[
                            {
                                id: "cardId",
                                desc: false
                            }
                        ]}
                        /*getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete') return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addCardOpen: true,
                                        editCard: rowInfo.original
                                    });
                                }
                            };
                            return {};
                        }}*/
                        SubComponent={row => (<CardSub card={row.original} currency={this.props.currency}/>)}
                        columns={[
                            {
                                Header: "Identification",
                                accessor: "cardId",
                                filterable: true,
                                Cell: row => (
                                    <div>
                                        {row.original.voucher ? (
                                            <Badge>Voucher</Badge>
                                        ) : (
                                            <Badge>Card</Badge>
                                        )} {row.original.cardId}
                                    </div>
                                )
                            },
                            {
                                Header: "Person ID",
                                accessor: "personId",
                                filterable: true,
                                sortable: false
                            },
                            {
                                Header: "Name",
                                accessor: "name",
                                filterable: true,
                                sortable: false
                            },
                            {
                                Header: "Credit",
                                accessor: "credit",
                                sortable: false,
                                Cell: row => (<Badge>{row.original.credit.toFixed(2)} {this.props.currency}</Badge>)
                            },
                            {
                                Header: "",
                                Cell: row => (
                                    <div>
                                        <a href="javascript:void(0);" onClick={() => {
                                            this.setState({
                                                deleteCardOpen:true,
                                                deleteCard: row.original
                                            })
                                            console.log(row.original);
                                        }}><i className="fa fa-trash"></i></a> | <a href="javascript:void(0);" onClick={() => {
                                            this.setState({
                                                quickCreditOpen: true,
                                                quickCreditCardId: row.original.cardId
                                            });
                                        }}><i className="fa fa-plus-square"/></a> | <a href="javascript:void(0);" onClick={() => {
                                            //Do the download
                                            const canvas = createCanvas();
                                            JsBarcode(canvas, row.original.cardId);
                                            console.log("Output", canvas.toDataURL());
                                            this.saveDataURI(canvas.toDataURL(), row.original.cardId+".png");
                                        }}><i className="fa fa-download"/></a> | <a href="javascript:void(0);" onClick={() => {
                                            this.setState({
                                                cardFieldsEdit: row.original
                                            })
                                        }}><i className="fa fa-pencil-alt"/></a>
                                    </div>
                                ),
                                sortable: false,
                                filterable: false,
                                width: 100
                            }
                        ]}
                        filterable
                        defaultPageSize={10}
                        className="-striped -highlight"
                        pageSize={10}
                    />
                </div>
            </div>
        );
    }
}

export default DevicesTab;